import Reflux from 'reflux';
import { Map } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import { ResponsiveDisplayModes } from 'flux/stores/cuesheet/CuesheetConstants';
import CuesheetResponsiveActions from 'flux/actions/cuesheet/CuesheetResponsiveActions';

/**
 * CuesheetResponsiveStore
 *
 */
export default Reflux.createStore({
  listenables: [CuesheetResponsiveActions],

  mixins: [BaseMixin],

  init() {
    this.setState(
      Map({
        showDetail: false,
        displayMode: ResponsiveDisplayModes.Table,
      }),
    );
  },

  onShowCueDetail() {
    this.setInStateAndTrigger('showDetail', true);
  },

  onHideCueDetail() {
    this.setInStateAndTrigger('showDetail', false);
  },

  onShowRowMenuModalFor(item) {
    this.setInStateAndTrigger('rowMenuVisibleFor', item);
    ModalActions.show(UIRegions.CuesheetItemMenu);
  },

  onHideRowMenuModal() {
    this.setState(this.getState().delete('rowMenuVisibleFor'));
    ModalActions.hide(UIRegions.CuesheetItemMenu);
  },

  onShowColumnConfigModal() {
    ModalActions.show(UIRegions.CuesheetColumnConfigMenu);
  },

  onHideColumnConfigModal() {
    ModalActions.hide(UIRegions.CuesheetColumnConfigMenu);
  },

  onUpdateModalField(field, value) {
    this.setInStateAndTrigger(['modal', 'fields', field], value);
  },

  onClearModalFields() {
    this.setStateAndTrigger(this.getState().deleteIn(['modal', 'fields']));
  },
});
